import { render, staticRenderFns } from "./courseTaskeight.vue?vue&type=template&id=ed72d5c4&scoped=true"
import script from "./courseTaskeight.vue?vue&type=script&lang=js"
export * from "./courseTaskeight.vue?vue&type=script&lang=js"
import style0 from "./courseTaskeight.vue?vue&type=style&index=0&id=ed72d5c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed72d5c4",
  null
  
)

export default component.exports